/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 9302a31b (Tue Nov  3 17:38:29 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
/**
 *
 * @export
 * @interface UnsharePlaylistRequestBody
 */
export interface UnsharePlaylistRequestBody {
  /**
   * The email address associated with the playlist share. It serves as the primary identifier for both active users and users not found.
   * @type string
   * @memberof UnsharePlaylistRequestBody
   */
  email: string
  /**
   * The unique identifier of a registered user. Include this field to revoke access for an active user.
   * @type string
   * @memberof UnsharePlaylistRequestBody
   */
  userKey?: string
}

export function UnsharePlaylistRequestBodyFromJSON(
  json: any
): UnsharePlaylistRequestBody {
  return UnsharePlaylistRequestBodyFromJSONTyped(json, false)
}

export function UnsharePlaylistRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UnsharePlaylistRequestBody {
  if (json === undefined || json === null) {
    return json
  }
  return {
    email: json['email'],
    userKey: !exists(json, 'userKey') ? undefined : json['userKey'],
  }
}

export function UnsharePlaylistRequestBodyToJSON(
  value?: UnsharePlaylistRequestBody | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    email: value.email,
    userKey: value.userKey,
  }
}
